module.exports = {
          srcSet: __webpack_public_path__ + "6f814b49f32a4c72052f8a9005354245-444.png"+" 444w",
          images:[ {path: __webpack_public_path__ + "6f814b49f32a4c72052f8a9005354245-444.png",width: 444,height: 168}],
          src: __webpack_public_path__ + "6f814b49f32a4c72052f8a9005354245-444.png",
          toString:function(){return __webpack_public_path__ + "6f814b49f32a4c72052f8a9005354245-444.png"},
          
          width: 444,
          height: 168
        }